import { toastOptions } from '@/hooks/useToast';
import { FieldErrors, FieldValues } from 'react-hook-form';
import { toast } from 'react-toastify';
import { formatFirstFormError } from './formatFirstFormError';

/** Tells the user why a submit was blocked instead of silently doing nothing. */
export const toastFirstFormError = <T extends FieldValues>(
  errors: FieldErrors<T>,
  fallback: string,
) => {
  toast.error(formatFirstFormError(errors) ?? fallback, toastOptions);
};
